import React from 'react';
export function Footer() {
  return <footer className="bg-[#040D0A] px-5 py-11 md:py-14 border-t border-acid/15" data-id="element-98" data-mp="32wd2cf6gdjt0">
      <div className="max-w-4xl mx-auto text-center" data-id="element-99" data-mp="3gg118925080a">
        <div className="font-display uppercase text-xl md:text-2xl text-white mb-2" data-id="element-100" data-mp="32nuh6bvv5gvk">
          Rugby <span className="text-acid" data-id="element-101" data-mp="36pfs3rou7l34">360</span>
        </div>
        <p className="text-gray-500 text-[0.6rem] md:text-xs uppercase tracking-[0.16em] font-medium mb-7 md:mb-8" data-id="element-102" data-mp="36pzaf9iegbho">
          The complete rugby coaching bible
        </p>

        <nav aria-label="Contact" className="flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-gray-400 text-xs md:text-sm mb-7 md:mb-9" data-id="element-103" data-mp="38zawx2kd95j">
          <a href="mailto:contact@rugby360.com" className="hover:text-acid transition-colors" data-id="element-104" data-mp="3qdf75eqfpeec">
            contact@rugby360.com
          </a>
          <a href="#" className="hover:text-acid transition-colors" data-id="element-105" data-mp="2a19uvpu8vuyv">
            @rugby360
          </a>
          <a href="#offer-details" className="hover:text-acid transition-colors" data-id="element-106" data-mp="2evx9mwzg5b09">
            Offer details
          </a>
        </nav>

        <p className="text-gray-600 text-[0.65rem] md:text-xs leading-relaxed max-w-xl mx-auto" data-id="element-107" data-mp="3gb8vj0znlauj">
          © Rugby 360™ 2026 — All rights reserved. Reproduction and
          redistribution without express authorization is prohibited. Digital
          product; you'll be charged in your local currency.
        </p>
      </div>
    </footer>;
}